import { tasAPI } from 'api'

export interface ToolsAndSupportParams {
  limit: number
  search: string
  page: number
  sortField: string[]
  sortDirection: string[]
  featured?: boolean
}

export const fetchToolsAndSupport = (params: ToolsAndSupportParams) => {
  return tasAPI.get('/tools-and-services', {
    params: {
      limit: params.limit,
      search: params.search,
      page: params.page,
      sortField: params.sortField,
      sortDirection: params.sortDirection,
    },
  })
}
